import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfig } from '../app-config.loader';
import { Stato } from '../shared/models/stato.model';
import { AnagraficaBaseService } from './anagrafica-base.service';

@Injectable({
  providedIn: 'root'
})
export class AnagraficaStatiService extends AnagraficaBaseService<Stato> {
  constructor(appConfig: AppConfig, http: HttpClient) {
    super(http, `${appConfig.settings.apiRoot}/AnagraficaStati`);
  }

  getAllVisibili(takeOne = false): Observable<Stato[]> {
    return this.getAll(takeOne).pipe(map(stati => stati.filter(s => s.visibile)));
  }

  get idProperty(): string {
    return 'statoId';
  }

  get nameProperty(): string {
    return 'nome';
  }
}
